// extracted by mini-css-extract-plugin
export default {"mobileSearchDropdownsPlaceholderContainer":"mobileSearchDropdownsPlaceholderContainer__ODJjN","mobileDropdownPlaceholder":"mobileDropdownPlaceholder__N2ZiZ"};